import { Outlet } from "react-router";
import { Menu } from "../components/menu/menu.jsx";
import { MenuItem } from "../components/menu/menuItem.jsx";
import { EmployeesIcon, KnowledgeBaseIcon, ProfileIcon } from "../assets/icons.jsx";
import { BackButton } from "../components/backButton/backButton.jsx";

export const SuperAdminTemplate = () => {
    const menuItems = [
        <MenuItem key="cafe" path="/superadmin/cafe" icon={<EmployeesIcon />} text="Предприятия" />,
        <MenuItem key="knowledge" path="/superadmin/knowledge" icon={<KnowledgeBaseIcon />} text="База знаний" />,
        <MenuItem key="profile" path="/superadmin/profile" icon={<ProfileIcon />} text="Профиль" />,
    ]

    return (
        <div className="page_container">
            <div className="page_content">
                <BackButton minPathnameLength={3} stopRoutes={["materials", "tests"]} />
                <Outlet />
            </div>
            <Menu>
                {menuItems}
            </Menu>
        </div>
    )
}